var exports = {
  "U": "ConfirmationQuestion__XJncOh",
};

module.exports = exports;
